import React from 'react';
import { useParams } from 'react-router-dom';
import MyProfile from './MyProfile';

// url segment → page; no segment = My profile. Account & security / Notification preferences / My clients land here as they are built.
const tabs = [
    { path: '', component: MyProfile },
];

const Account: React.FC = () => {
    const { tab = '' } = useParams<{ tab?: string }>();
    const current = tabs.find(x => x.path === tab) ?? tabs[0];

    // each page renders its own .page-header (Save button differs per page) above the AccountNav row
    return <div className="v2-page account-v2">
        <current.component />
    </div>;
};

export default Account;
